import { TargetedFinancialInstruments } from '../components';
import { useTargetedFinancialInstruments } from '../hooks';
import { PageComponentProps } from '../types';

export const TargetedFinancialInstrumentsStep = ({
  canGoBack,
}: PageComponentProps) => {
  const { initialValues, submitLoading, onSubmit, goToBack } =
    useTargetedFinancialInstruments();

  return (
    <TargetedFinancialInstruments
      canGoBack={canGoBack}
      initialValues={initialValues}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
